import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M11.9537 2.40122C16.6922 2.40122 20.411 5.65487 21.2867 9.70092C21.6106 11.1897 21.5747 12.6544 21.1908 14.0711C19.5713 20.0622 24.3098 22.4754 18.9955 21.1427C17.232 20.6985 15.3846 20.5784 13.5972 20.8906C12.2057 21.1307 10.8021 21.0587 9.42255 20.6865C5.78771 19.714 3.0166 16.6404 2.51277 13.0266C1.68503 7.20365 6.32754 2.40122 11.9537 2.40122ZM11.9537 0C4.80403 0 -0.882146 6.15912 0.113535 13.3628C0.749331 17.9491 4.22822 21.8031 8.78675 23.0157C10.4782 23.4719 12.2296 23.568 13.9931 23.2558C15.4566 23.0037 16.9681 23.1117 18.4077 23.4719L20.1591 23.9041C22.4264 24.4684 24.4777 22.4514 23.9019 20.2303C23.9019 20.2303 23.578 18.9816 23.566 18.9456C23.2061 17.5529 23.1222 16.0882 23.506 14.6955C23.9739 12.9786 24.0459 11.1176 23.626 9.18466C22.5223 4.10608 17.8438 0 11.9537 0Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
